import React, { useEffect, useState } from "react";
import AdminNavbar from "../../../components/admin_navbar";
import AdminSideMenu from "../../../components/admin_side_menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const CreditNoteDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [invoice, setInvoice] = useState({});
  const [vat, setVat] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);

    var url = apiBaseURL + "/invoices/" + id;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoiceData = JSON.parse(JSON.stringify(response.data));
        setInvoice(invoiceData);

        // Format the numbers with commas and 2 decimal places
        setVat(
          (invoiceData.vat || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        setGrandTotal(
          (invoiceData.grand_total || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      })
      .catch((err) => console.error("fetchInvoices err = " + err.message));
  }, [apiBaseURL, id, navigate]);

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Credit Note Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">
                Credit Note #{invoice.invoice_number}
              </h1>
              <p className="dashboard-subtitle">
                Credit note details and ETIMS information
              </p>
            </div>
          </div>

          {/* Credit Note Details Cards */}
          <div className="invoice-details-horizontal">
            {/* Customer Information Card */}
            <div className="detail-card-horizontal">
              <h4>👤 Customer Information</h4>
              <div className="detail-items-grid">
                <div className="detail-item-horizontal">
                  <span className="detail-label">Customer Name</span>
                  <span className="detail-value">
                    {invoice.customer_name || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Customer TIN</span>
                  <span className="detail-value code">
                    {invoice?.customer_tin || "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* Credit Note Information Card */}
            <div className="detail-card-horizontal">
              <h4>📋 Credit Note Information</h4>
              <div className="detail-items-grid">
                <div className="detail-item-horizontal">
                  <span className="detail-label">Credit Note Number</span>
                  <span className="detail-value code">
                    {invoice.invoice_number}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Credit Date</span>
                  <span className="detail-value date">
                    {invoice.created_at}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">VAT Amount</span>
                  <span className="detail-value currency">KES {vat}</span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Grand Total</span>
                  <span className="detail-value currency">
                    KES {grandTotal}
                  </span>
                </div>
              </div>
            </div>

            {/* ETIMS Information Card */}
            <div className="detail-card-horizontal">
              <h4>🔐 ETIMS Information</h4>
              <div className="detail-items-grid">
                <div className="detail-item-horizontal">
                  <span className="detail-label">Internal Data</span>
                  <span className="detail-value code">
                    {invoice?.etims_internal_data || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">MRC Number</span>
                  <span className="detail-value code">
                    {invoice?.etims_mrc_number || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Receipt Number</span>
                  <span className="detail-value code">
                    {invoice?.etims_receipt_number || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Receipt Signature</span>
                  <span className="detail-value code">
                    {invoice?.etims_receipt_signature || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">Result Date & Time</span>
                  <span className="detail-value date">
                    {invoice?.etims_result_date_time || "N/A"}
                  </span>
                </div>
                <div className="detail-item-horizontal">
                  <span className="detail-label">SDC ID</span>
                  <span className="detail-value code">
                    {invoice?.etims_sdcid || "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced Verification Section */}
          <div className="verification-section-horizontal">
            <div className="verification-header-horizontal">
              <img
                alt="KRA Logo"
                src="/assets/kra_logo.jpg"
                className="tra-logo-horizontal"
              />
              <div>
                <h3 className="verification-title">Official Verification</h3>
                <p className="verification-subtitle">
                  Kenya Revenue Authority Digital Signature
                </p>
              </div>
            </div>

            <div className="verification-grid">
              <div className="verification-item">
                <span className="detail-label">Signed Date</span>
                <span className="detail-value date">
                  &nbsp;{invoice.signed_date || "N/A"}
                </span>
              </div>
              <div className="verification-item">
                <span className="detail-label">Verification URL</span> &nbsp;
                <a
                  href={invoice.verification_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="detail-value verification-link"
                >
                  {invoice.verification_url || "N/A"}
                </a>
              </div>
              <div className="verification-item">
                <span className="detail-label">Digital Signature</span> &nbsp;
                <span className="detail-value code">
                  {invoice.signature || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CreditNoteDetail;
